// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__OI0H0","colMin":"styles_colMin__1FEy_"};